'use strict';



import ContainerDimensions from 'react-container-dimensions'
const $ = require('jquery');
require('slick-carousel');
const PREVIOUS = 'PREVIOUS';
const NEXT = 'NEXT';
const speed = 300;



const arrowLabels = {
  [PREVIOUS]: 'Previous',
  [NEXT]: 'Next'
};



const arrowIcons = {
  [PREVIOUS]: `<span class='icon-chevron-left'></span>`,
  [NEXT]: `<span class='icon-chevron-right'></span>`
};



const arrow = direction =>
  `<button class='c-gallery__control' type='button' aria-label=${arrowLabels[direction]}>${arrowIcons[direction]}</button>`;



render();
$('.js-append-around').appendAround();



function render($gallery = $('.js-gallery')) {

  if ($gallery.length === 0) {
    return
  }

  const $content = $gallery.find('.js-gallery-content');
  const $navigation = createNavigation($content);
  $navigation.appendTo($gallery.find('.js-gallery-navigation'));

  $content.slick({
    asNavFor: $navigation,
    prevArrow: arrow(PREVIOUS),
    nextArrow: arrow(NEXT),
    appendArrows: $gallery.find('.js-gallery-controls'),
    speed
  });

  const { $slides } = $content.slick('getSlick');
  let prevSlide
  handleGraphSlide($slides.eq($content.slick('slickCurrentSlide')))

  /*
   * Patch for a Slick bug
   */
  $content.on('beforeChange', (e, slick, previous, next) => {

    const { $slides } = $navigation.slick('getSlick');
    const activeClassname = 'slick-current';

    $slides.eq(next)
      .addClass(activeClassname)
      .siblings()
      .removeClass(activeClassname);

  })

  $content.on('beforeChange', (e, slick, current, next) => {
    const { $slides } = slick
    prevSlide = current
    handleGraphSlide(
      $slides.eq(next)
    )
  })

}



function createNavigation($gallery) {

  if($gallery.navigation) {
    return $gallery.navigation;
  }

  if($gallery.find('.js-gallery-image').length < 2) {
    return $('<div />').hide();
  }

  const $navigation = $gallery.navigation = $gallery.clone();
  const slidesToShow = 4;

  $navigation.slick({
    asNavFor: $gallery,
    focusOnSelect: true,
    arrows: false,
    draggable: false,
    infinite: true,
    slidesToShow,
    speed
  });

  const { $slides } = $navigation.slick('getSlick');

  $navigation
    .find('.js-gallery-dfl-graph')
    .addClass('c-gallery__navigation-item--graph')
    .empty()
    .append(`<span class='c-gallery__navigation-icon  icon-line-chart'></span>`)

  $slides.addClass('c-gallery__navigation__item')

  if($slides.length > slidesToShow) {
    $navigation.slick('slickSetOption', 'centerMode', true);
    $navigation.slick('slickSetOption', 'centerPadding', 6  * 6 + 'px');
  }

  if($slides.length <= slidesToShow) {
    $navigation.find('.slick-slide').css({ maxWidth: '4.5rem' });
  }

  return $navigation;

}



function handleGraphSlide ($nextSlide, $prevSlide) {
  const className = 'js-gallery-dfl-graph'
  const isGraph = $slide => $slide && $slide.hasClass(className)
  const getTarget = $slide => $slide && $slide[0].querySelector('.js-target')

  ;(async () => {
    const [ React, reactDom, DflGraph ] = await Promise.all([
      import('react'),
      import('react-dom'),
      import('../components/dfl-graph')
    ])

    if (isGraph($nextSlide)) {
      const target = getTarget($nextSlide)
      if (target) {
        reactDom.render((
          <ContainerDimensions>
            {({ width, height }) => (
              <DflGraph.default
                drawdowns={JSON.parse(target.dataset.drawdowns)}
                land={JSON.parse(target.dataset.land)}
                gdv={Number(target.dataset.gdv)}
                width={width}
                height={height}
                interactive={false}
              />
            )}
          </ContainerDimensions>
        ), target)
      }
    }

    if (isGraph($prevSlide)) {
      reactDom.unmountComponentAtNode(
        getTarget($prevSlide)
      )
    }
  })()
}
